var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(_vm.banner, {
    tag: "component",
    attrs: { "has-box-shadow": _vm.hasBoxShadow, text: _vm.text },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }